<template>
  <!-- Thumb-sized and stacked on phones (main action on top), one row from sm up. -->
  <div class="flex w-full flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-between">
    <AppButton
      :label="secondaryLabel"
      variant="ghost"
      tone="muted"
      size="lg"
      :disabled="loading"
      data-test="dialog-secondary"
      @click="$emit('secondary')"
    />
    <AppButton
      :label="primaryLabel"
      tone="primary"
      size="lg"
      :loading="loading"
      data-test="dialog-primary"
      @click="$emit('primary')"
    />
  </div>
</template>

<script setup>
  import AppButton from '@/components/ui/buttons/AppButton.vue';

  defineOptions({ name: 'DialogActions' });
  defineProps({
    primaryLabel: { type: String, required: true },
    secondaryLabel: { type: String, required: true },
    loading: { type: Boolean, default: false },
  });
  defineEmits(['primary', 'secondary']);
</script>
